/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Maria_Ward_Schule_Badhomburg6Inputs */

const en__field__enum_schoolname_maria_ward_schule_badhomburg6 = /** @type {(inputs: _Field__Enum_Schoolname_Maria_Ward_Schule_Badhomburg6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bad Homburg`)
};

const de__field__enum_schoolname_maria_ward_schule_badhomburg6 = /** @type {(inputs: _Field__Enum_Schoolname_Maria_Ward_Schule_Badhomburg6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maria-Ward-Schule`)
};

/**
* | output |
* | --- |
* | "Bad Homburg" |
*
* @param {_Field__Enum_Schoolname_Maria_Ward_Schule_Badhomburg6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_maria_ward_schule_badhomburg6 = /** @type {((inputs?: _Field__Enum_Schoolname_Maria_Ward_Schule_Badhomburg6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Maria_Ward_Schule_Badhomburg6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_maria_ward_schule_badhomburg6(inputs)
	return de__field__enum_schoolname_maria_ward_schule_badhomburg6(inputs)
});
export { _field__enum_schoolname_maria_ward_schule_badhomburg6 as "_field__enum_schoolName_Maria_Ward_Schule_BadHomburg" }